export enum EntityCategory{
  Unknown = 0,
  JobType = 1,
  ProjectStatus = 2,
  Area = 3,
  ClientEngineer = 4,
  InstallationProgress = 5,
  WorkGroup = 6,
  WorkShift = 7,
  MaterialProcurementStatus = 8  
};
